import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { trackPageView, getConsent } from "@/lib/analytics";

/**
 * Auto-tracks page views on route change. Respects consent.
 */
export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    if (getConsent() !== "accepted") return;
    // Small delay so document.title updates first if needed
    const t = setTimeout(() => {
      trackPageView(location.pathname + location.search, user?.id || null);
    }, 50);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search]);

  // Re-fire pageview when consent changes from declined→accepted, to capture current page
  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      if (detail === "accepted") {
        trackPageView(location.pathname + location.search, user?.id || null);
      }
    };
    window.addEventListener("plateia-consent-changed", handler);
    return () => window.removeEventListener("plateia-consent-changed", handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search, user?.id]);

  return <>{children}</>;
}
